import moment from 'moment';

export const WAITING_FOR_INSPECTION_TYPES = {
    fpbo: {
        label: 'FPBO',
        reportPrefix: '4',
        detailPathPrefix: '/waiting-for-inspection/fpbo'
    },
    lpbo: {
        label: 'LPBO',
        reportPrefix: '5',
        detailPathPrefix: '/waiting-for-inspection/lpbo'
    },
    fai: {
        label: 'FAI',
        reportPrefix: '6',
        detailPathPrefix: '/waiting-for-inspection/fai'
    }
};

export function buildWaitingForInspectionRows(recordsByType) {
    return Object.entries(WAITING_FOR_INSPECTION_TYPES)
        .flatMap(([recordType, typeConfig]) => {
            const records = Array.isArray(recordsByType[recordType]) ? recordsByType[recordType] : [];

            return records
                .filter((record) => record.approve_status === 0 || record.approve_status === '0')
                .map((record) => {
                    const submittedAt = moment(record.Timestamp);
                    if (!record.id || !submittedAt.isValid()) return null;

                    return {
                        id: record.id,
                        type: typeConfig.label,
                        reportNo: submittedAt.format('YYYYMMDD') + typeConfig.reportPrefix + record.id,
                        partNo: record.master ? record.master.partNo || '' : '',
                        description: record.master ? record.master.partDesc || '' : '',
                        jobNo: record.jobNo || '',
                        submittedAt: submittedAt.format('YYYY-MM-DD HH:mm:ss'),
                        submittedTimestamp: submittedAt.valueOf(),
                        detailPath: typeConfig.detailPathPrefix + '/' + record.id
                    };
                })
                .filter(Boolean);
        })
        .sort((first, second) => second.submittedTimestamp - first.submittedTimestamp);
}
